(ns frontend.view.components.power-search.recents.view
  (:require
   [frontend.view.components.power-search.recent.view :as recent]
   [re-frame.core :as rf]
   [frontend.view.components.power-search.event :as event]
   [frontend.state.current-session :as session]
   [common.localization :as loc]))

(defn recents
  [props]
  (fn [{:keys [input-focused?]}]
    (let [{:keys [results queries]} (get-in @session/view-config [:universal-search :recents])]
      [:div
       {:class "mb-0 hidden md:flex flex-col w-[300px] text-sm border-l border-solid border-base-light-border-paler"}
       [:div
        {:class "p-3 flex flex-col gap-2"}
        [:h2
         {:class "pb-2 font-bold text-xl"}
         (loc/tr :recent-searches)]
        (if (empty? results)
          [:div
           {:class "text-base-light-text-paler"}
           (loc/tr :no-searches)]
          (->> queries
               (map-indexed
                (fn [i search-query]
                  ^{:key (str "search-query-" search-query)}
                  [recent/recent
                   {:search-query search-query
                    :tab-index    (+ 10000 0 i)
                    :active?      false
                    :on-remove    (fn [event]
                                    (rf/dispatch [::event/remove-recent-query search-query]))
                    #_(and (= 0 i) input-focused?)}]))))]
       [:div
        {:class "p-3 flex flex-col gap-2 flex-1"}
        [:h2
         {:class "pb-2 text-base-light-text font-bold text-xl"}
         (loc/tr :recently-selected)]
        (if (empty? results)
          [:div
           {:class "text-base-light-text-paler"}
           (loc/tr :no-items)]
          (->> results
               (map-indexed
                (fn [i result]
                  ^{:key (:db/id result)}
                  [recent/recent
                   {:result    result
                    :tab-index (+ 10100 i)
                    :on-remove (fn [event]
                                 (rf/dispatch [::event/remove-recent-result (:db/id result)]))
                    :active?   (and (= 0 i) input-focused?)}]))))]])))
